import { DealFinderState } from '@model/state/deal-finder-state';
import { SearchType } from '@model/iceberg/deal-finder/deal-finder';
import { FILTER_DEFAULTS } from '@model/price-calendar';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { performSearch } from '@state/slices/deal-finder-results/dealFinderResultsSlice';
import { DealFinderActions } from '@state/slices/deal-finder/dealFinderSlice';

export enum DealFinderLastSearchedActions {
  NAME = '@DEAL_FINDER_LAST_SEARCHED',
  SET_LAST_SEARCHED = '@DEAL_FINDER_LAST_SEARCHED/setLastSearched'
}

export const INITIAL_DEAL_FINDER_LAST_SEARCHED_STATE: DealFinderState = {
  searchType: SearchType.MAIN,
  duration: FILTER_DEFAULTS.duration,
  date: '',
  month: '',
  destinations: [],
  airports: [],
  flexibleDays: 0,
  occupancy: [{ adults: 2, children: [] }],
  preferredBoardBasis: '',
  hotelLandingSearch: false,
  destinationSearch: false,
  errors: {
    airports: false,
    dates: false,
    destinations: false,
    occupancy: false
  }
};

const dealFinderLastSearchedSlice = createSlice({
  name: DealFinderLastSearchedActions.NAME,
  initialState: INITIAL_DEAL_FINDER_LAST_SEARCHED_STATE,
  reducers: {
    setLastSearched(state: DealFinderState, action: PayloadAction<any>) {
      return { ...state, ...action.payload };
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(DealFinderActions.RECEIVE_CRITERIA_SUCCESS, (state, action: any) => {
        return { ...state, ...action.payload };
      })
      .addCase(performSearch.fulfilled, (state, action: any) => {
        return { ...state, ...action.payload };
      });
  }
});

export const { setLastSearched } = dealFinderLastSearchedSlice.actions;

export const dealFinderLastSearchedReducer = dealFinderLastSearchedSlice.reducer;
